module.exports = __webpack_public_path__ + "img/3-4.3c4512d4.svg";